import axios from 'axios'
import cookies from 'vue-cookies'
import SocketioChatService from '~/services/socketio/socketio.chat.service.js'
export default {
  namespaced: true,
  state: {
    status: '',
    token: cookies.get('token'),
    next_step: '',
  },
  mutations: {
    checkEmailConfirm(state, next_step) {
      state.next_step = next_step
    },
    auth_request(state) {
      state.status = 'loading'
    },
    auth_success(state, token) {
      state.status = 'success'
      state.token = token
      state.next_step = ''
    },
    auth_error(state) {
      state.status = 'error'
    },
    logout(state) {
      state.status = ''
      state.token = ''
    },
  },
  getters: {
    isLoggedIn: (state) => !!state.token,
    authStatus: (state) => state.status,
    authToken: (state) => state.token,
    nextStep: (state) => state.next_step,
  },
  actions: {
    checkEmail({ rootState, commit }, data) {
      return new Promise((resolve, reject) => {
        // commit('auth_request')
        axios({
          url: rootState.apiDomain + '/api/auth/check-email',
          data: data,
          method: 'POST',
        })
          .then((resp) => {
            const next_step = resp.data.next_step
            commit('checkEmailConfirm', next_step)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    AUTH_login({ commit, dispatch, rootState, rootGetters }, { data, save }) {
      return new Promise((resolve, reject) => {
        commit('auth_request')
        axios({
          url: rootState.apiDomain + '/oauth/token',
          data,
          method: 'POST',
        })
          .then((resp) => {
            const token = resp.data.access_token
            cookies.set(
              'token',
              token,
              save ? '1m' : 0,
              null,
              null,
              rootGetters.checkUseProtocol,
              'Strict',
            )
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
            commit('auth_success', token)
            dispatch('firebase/onFirebaseInit', { login: true }, { root: true })
            dispatch('user/CHANGE_userLanguage', null, { root: true })
            // commit('SET_loginIsSave', save)
            if (!save) {
              cookies.set(
                'isSessionAuth',
                true,
                0,
                null,
                null,
                rootGetters.checkUseProtocol,
                'Strict',
              )
            }
            resolve(resp)
          })
          .catch((err) => {
            if (err.response) {
              dispatch(
                'popup/onMessage',
                {
                  message: err.response.data.message,
                  isError: true,
                },
                { root: true },
              )
              commit('auth_error')
              cookies.remove('token')
              reject(err)
            }
          })
      })
    },
    logout({ commit, dispatch }) {
      return new Promise((resolve) => {
        dispatch('firebase/deleteCurentToken', null, { root: true })
        // commit('user/setUserData', '', { root: true })
        commit('logout')
        commit('offerAgreement/setOfferAgreementNotAccepted', false, { root: true })
        dispatch('user/resetState', null, { root: true })
        // cookies.remove('token')
        // cookies.remove('chat_token')
        cookies.keys().forEach((cookie) => {
          if (cookie !== 'languageSelect') {
            cookies.remove(cookie)
          }
        })
        localStorage.removeItem('NoFirstLogin')
        delete axios.defaults.headers.common['Authorization']
        SocketioChatService.disconnect()
        resolve()
      })
    },
    register({ rootState }, user) {
      return new Promise((resolve, reject) => {
        // commit('auth_request')
        axios({
          url: rootState.apiDomain + '/api/auth/register',
          data: user,
          method: 'POST',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    registerConfirm({ commit, rootState }, user) {
      return new Promise((resolve, reject) => {
        commit('auth_request')
        axios({
          url: rootState.apiDomain + '/api/auth/confirm',
          data: user,
          method: 'POST',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            commit('auth_error', err)
            reject(err)
          })
      })
    },
    passwordChange({ commit, rootState }, user) {
      return new Promise((resolve, reject) => {
        // commit('auth_request')
        axios({
          url: rootState.apiDomain + '/api/auth/restore',
          data: user,
          method: 'POST',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            commit('auth_error', err)
            reject(err)
          })
      })
    },
    passwordChangeConfirm({ commit, rootState }, user) {
      return new Promise((resolve, reject) => {
        // commit('auth_request')
        axios({
          url: rootState.apiDomain + '/api/auth/confirm-restore',
          data: user,
          method: 'POST',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            commit('auth_error', err)
            reject(err)
          })
      })
    },
  },
}
